import { format } from "date-fns";
import { useState } from "react";
import { Container } from "@/components/atoms";
import {
  SubscriptionPlanSection,
  PaymentInformation,
  SubscriptionBillingHistory,
  CancelSubscriptionSection,
  CancelSubscriptionModal,
} from "@/components/organisms";
import { useOperator } from "@/hooks";
import { useGetProviderSubscriptionsQuery, useCancelProviderSubscriptionMutation } from "@/redux/apis/subscription/subscriptionPlansApi";
import { addToast } from "@/utils";
import { getErrorMessages } from "@/helpers/reduxHelpers";

export const Subscriptions = () => {
  const operator = useOperator();
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const { data: subscriptions } = useGetProviderSubscriptionsQuery({
    providerId: operator.id,
    status: ["active", "pending_cancellation", "trial"],
    limit: 1,
    orderBy: ["startDate:DESC"],
  });

  const [cancelSubscription, { isLoading: isCancelling }] = useCancelProviderSubscriptionMutation();

  const activeSubscription = subscriptions?.[0];
  const subscriptionEndDate = activeSubscription?.billingCycleEnd
    ? format(new Date(activeSubscription.billingCycleEnd), "MMMM d, yyyy")
    : "";

  const handleCancel = async () => {
    if (!activeSubscription) {
      addToast("danger", "No active subscription found");
      return;
    }

    try {
      await cancelSubscription({
        providerId: operator.id,
        subscriptionAssignmentId: activeSubscription.subscriptionAssignmentId,
      }).unwrap();

      addToast("success", "Subscription cancelled successfully");
      setIsCancelModalOpen(false);
      window.location.reload();
    } catch (error) {
      getErrorMessages(error as Parameters<typeof getErrorMessages>[0]).forEach((m) => addToast("danger", m));
    }
  };

  return (
    <Container className="flex w-full max-w-[1040px] flex-1 flex-col gap-4 py-4">
      <SubscriptionPlanSection />
      <PaymentInformation />
      <SubscriptionBillingHistory />
      <CancelSubscriptionSection onCancelClick={() => setIsCancelModalOpen(true)} />

      <CancelSubscriptionModal
        open={isCancelModalOpen}
        onClose={() => setIsCancelModalOpen(false)}
        subscriptionEndDate={subscriptionEndDate}
        onCancel={handleCancel}
        isCancelling={isCancelling}
      />
    </Container>
  );
};
